import { z } from "zod";

export const BanRecordSchema = z.object({
  id: z.number(),
  hubUserId: z.number().nullable(),
  defiAddress: z.string().nullable(),
  exchangeId: z.string().nullable(),
  exchangeUserId: z.string().nullable(),
  ipHash: z.string().nullable(),
  createdAt: z.coerce.date(),
  expiresAt: z.coerce.date().nullable(),
  reasonForBan: z.string().nullable(),
});

export type BanRecord = z.infer<typeof BanRecordSchema>;

export const BanRecordResponseSchema = z.array(BanRecordSchema);
export type BanRecordResponse = z.infer<typeof BanRecordResponseSchema>;
